export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const COMMANDS = editor.Commands;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({
        defaults:{
            ...MODEL.prototype.defaults,
            tagName:'div',
            droppable: false,
            attributes:{
                "data-slg-type":"C-GENDER-RADIO"
            },
            components:[
                {
                    tagName:'div',
                    classes:["form-check"],
                    components:[
                        {
                            type:'radio',
                            attributes:{
                                value: "H",
                                name: "gender"
                            },
                            classes:['form-check-input']

                        },
                        {
                            type:'label',
                            attributes:{
                                for:""
                            },
                            classes:['form-check-label'],
                            content: "Sr",
                        }
                    ]
                },
                {
                    tagName:'div',
                    classes:["form-check"],
                    components:[
                        {
                            type:'radio',
                            attributes:{
                                value: "W",
                                name: "gender"
                            },
                            classes:['form-check-input']

                        },
                        {
                            type:'label',
                            attributes:{
                                for:""
                            },
                            classes:['form-check-label'],
                            content: "Sra"
                        }
                    ]
                }
            ],
            traits: [
                {
                    type: 'class_select',
                    options: [
                        {value: '', name: 'None'},
                        {value: 'form-check-inline', name: 'Inline'},
                    ],
                    label: 'Order'
                }
            ].concat(MODEL.prototype.defaults.traits)
        }
        
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-GENDER-RADIO")
                return { type:'C-GENDER-RADIO' }
        }
    });

    let view = VIEW.extend({
        
        /**
         * Trigger when the render is completed
         */
        onRender() {
            // render the button and modal
            let component = this.model;
            let components = component.components();
            for (let i = 0; i < components.length; i++) {
                const element = components.at(i);
                let radio = element.findType('radio')[0];
                let label = element.findType('label')[0];
                let attribute_for = label.getAttributes()['for'];
                if(!attribute_for || attribute_for == ''){
                    label.addAttributes({'for': radio.getId()});
                }

            }
        },
    });

    DOMC.addType('C-GENDER-RADIO', {
      model: model,
      view
    });
    
  };
  